import { useMemo, useRef } from "react";
import moment from "moment/moment";
import CalendarIcon from "../../icons/CalendarIcon";
import ArrowLeftIcon from "../../icons/ArrowLeftIcon";
import ArrowRightIcon from "../../icons/ArrowRightIcon";

function DateQuickPicker({ value, onChange }) {
	const inputRef = useRef(null);

	const selectedDate = useMemo(() => {
		const parsed = moment(value, "YYYY-MM-DD", true);
		return parsed.isValid() ? parsed : moment();
	}, [value]);

	const selectedValue = selectedDate.format("YYYY-MM-DD");

	const openNativePicker = () => {
		if (!inputRef.current) return;
		if (typeof inputRef.current.showPicker === "function") inputRef.current.showPicker();
		else inputRef.current.click();
	};

	const setDate = (nextValue) => {
		if (!nextValue || typeof onChange !== "function") return;
		onChange(nextValue);
	};

	const moveDay = (offset) => {
		const next = selectedDate.clone().add(offset, "day").format("YYYY-MM-DD");
		setDate(next);
	};

	return (
		<div className="date-quick-picker">
			<button
				type="button"
				className="date-quick-nav"
				onClick={() => moveDay(-1)}
				aria-label="Giorno precedente"
			>
				<ArrowLeftIcon />
			</button>

			<button
				type="button"
				className="date-quick-main"
				onClick={openNativePicker}
				aria-label="Seleziona data"
			>
				<CalendarIcon />
				<span className="date-quick-main-text">{selectedDate.format("DD/MM/YYYY")}</span>
			</button>

			<button
				type="button"
				className="date-quick-nav next"
				onClick={() => moveDay(1)}
				aria-label="Giorno successivo"
				>
					<ArrowRightIcon />
				</button>

				<input
				ref={inputRef}
				className="date-quick-native-input"
				type="date"
				value={selectedValue}
				onChange={(e) => setDate(e.target.value)}
				tabIndex={-1}
				aria-hidden="true"
			/>
		</div>
	);
}

export default DateQuickPicker;
